import React, { Component } from "react";
import Row from "../../containers/row";
import FlexText from "../../flexText";
import TitleBar from "../../titleBar";
import BoxText from "../../overlays/boxText/boxText";
import Gutters from "../../config/gutters";
import VideoHead from "../../video/VideoHead";
import Styles from "./styles/styles";
import gutter from "../../config/vars";
class TextOnlyRow extends Component {
  returnBackground(background) {
    const bg = {
      bgimg: "",
      bgc: "",
      bgh: "",
      padding: "120px " + gutter + " 60px " + gutter,
      boxText: true,
      bgSize: "contain",
    };
    const width = window.innerWidth;
    if (typeof this.props.data.field_link_2 !== "undefined") {
      bg.bgh = window.innerWidth < 900 ? 600 : "";
      return bg;
    }
    if (this.props.bgimage !== "") {
      let height = this.props.bgimage.height;
      //TODO use utility function
      if (width < 600) {
        height =
          (window.innerWidth * this.props.bgimage.height) /
          this.props.bgimage.width;
        bg.bgimg = this.props.bgimage.uri.replace(
          "/files/styles/1200/public/",
          "/files/styles/600/public/"
        );
      } else if (width < 899) {
        height =
          (window.innerWidth * this.props.bgimage.height) /
          this.props.bgimage.width;
        bg.bgimg = this.props.bgimage.uri.replace(
          "/files/styles/1200/public/",
          "/files/styles/900/public/"
        );
      } else {
        bg.bgimg = this.props.bgimage.uri;
        height =
          ((window.innerWidth > 1200 ? 1200 : window.innerWidth) *
            this.props.bgimage.height) /
          this.props.bgimage.width;
      }
      bg.bgc = "";
      bg.bgh = height;
      /*------Image defined in styles begin----------*/
    } else if (typeof background.attributes.field_image !== "undefined") {
      bg.bgc = "";
      if (width > 899) {
        bg.bgimg = background.attributes.field_image.uri;
        bg.bgh = background.attributes.field_image.height;
      } else if (
        !background.attributes.field_image_1.uri.includes("nomobile")
      ) {
        bg.bgSize = "cover";
        bg.bgimg = background.attributes.field_image_1.uri;
        bg.bgh = background.attributes.field_image_1.height900;
      }
      bg.boxText = false;
      /*------Background Color as Default---------------------*/
    } else {
      bg.bgimg = "";
      bg.bgc = background.attributes.field_color_1;
      bg.padding = "24px " + gutter + " 60px " + gutter;
      bg.boxText = false;
    }
    return bg;
  }
  returnVideo() {
    const rowdata = this.props.data.field_row_content[0];
    if (typeof this.props.data.field_link_2 !== "undefined") {
      return (
        <VideoHead
          className="headVideo"
          id="headerVideo"
          width="100%"
          autoPlay="autoplay"
          loop="loop"
          media={this.props.data.field_link_2}
          title={
            typeof rowdata.field_text_1 !== "undefined" &&
            window.innerWidth >= 900
              ? rowdata.field_text_1
              : null
          }
          blockStyle={this.props.blockStyle}
        />
      );
    } else return null;
  }
  returnTitleBar() {
    if (this.props.data.field_boolean_2 !== "0") {
      return (
        <TitleBar
          className="torTitlebar"
          title={this.props.field_text_1}
          tag="p"
          center={this.props.data.field_boolean_1}
          color={
            this.props.blockStyle.attributes.field_title_color_font[0]
              .field_color_1
          }
          bgc={
            this.props.blockStyle.attributes.field_title_color_font[0]
              .field_bgcolor_1
          }
          fontFamily={
            this.props.blockStyle.attributes.field_title_color_font[0]
              .field_font_1.name
          }
          divStyles={{
            boxSizing: "border-box",
            borderRadius: "2px",
            boxShadow: "0 2px 2px 0 rgba(0,0,0,0.1)",
            position: "absolute",
            top: "24px",
            left: "24px",
            display: "block",
          }}
        >
          {this.props.data.field_text_1}
        </TitleBar>
      );
    } else return null;
  }
  returnHeader(boxText, field_text_1) {
    const center = this.props.data.field_boolean_1 ? "center" : "left";
    if (
      typeof field_text_1 !== "undefined" &&
      typeof this.props.data.field_link_2 === "undefined"
    ) {
      if (window.innerWidth > 899 || !boxText) {
        return (
          <FlexText
            className="torHeader"
            color={
              this.props.blockStyle.attributes.field_heading_color_font[0]
                .field_color_1
            }
            tag="h2"
            min="32"
            pert="0.025"
            max={window.innerWidth < 899 ? 32 : 40}
            styles={{
              fontFamily: "Oswald",
              padding: "0 " + gutter,
              width: "100%",
              display: "inline-block",
              textTransform: "uppercase",
              textAlign: window.innerWidth < 899 ? "center" : center,
              fontWeight: "bold",
              textShadow: "1px 1px 2px rgba(0, 0, 0, 0.3)",
            }}
          >
            {field_text_1}
          </FlexText>
        );
      } else if (window.innerWidth < 900) {
        return null;
      }
    } else return null;
  }
  returnBoxTextOrNot(bg, field_longtext_1, field_text_1) {
    if (field_longtext_1 !== "undefined" && bg.boxText === true) {
      return (
        <BoxText
          blockStyle={this.props.blockStyle}
          tag="div"
          color={
            this.props.blockStyle.attributes.field_text_color_font[0]
              .field_color_1
          }
          max="20"
          min="20"
          text={typeof field_text_1 !== "undefined" ? field_text_1 : null}
          video={typeof this.props.data.field_link_2 !== "undefined"}
          height={bg.bgh}
          styles={{
            marginRight: "auto",
            marginLeft: "auto",
            fontFamily: "Roboto",
            textTransform: "none",
            padding: "0px " + gutter,
          }}
        >
          {field_longtext_1}
        </BoxText>
      );
    } else
      return (
        <FlexText
          tag="div"
          color={
            this.props.blockStyle.attributes.field_text_color_font[0]
              .field_color_1
          }
          max="20"
          min="20"
          styles={{
            marginRight: "auto",
            textAlign: window.innerWidth < 900 ? "left" : "center",
            marginLeft: "auto",
            fontFamily: "Roboto",
            textTransform: "none",
            padding: window.innerWidth < 900 ? "24px" : "0px",
          }}
        >
          {field_longtext_1}
        </FlexText>
      );
  }
  render() {
    let innerTopGutter = Gutters.spacings[this.props.blockStyle.inner_top];
    if (this.props.data.field_boolean_2 !== "0") {
      innerTopGutter += window.innerWidth < 900 ? 104 : 48;
    }
    const linkColor = this.props.blockStyle.attributes.field_link_colors.name;
    const bg = this.returnBackground(this.props.blockStyle);
    const rowdata = this.props.data.field_row_content[0];
    const margin =
      Gutters.spacings[this.props.blockStyle.top] +
      "px 0px " +
      Gutters.spacings[this.props.blockStyle.btm] +
      "px 0px";
    let padding =
      innerTopGutter +
      "px " +
      gutter +
      " " +
      Gutters.spacings[this.props.blockStyle.inner_btm] +
      "px " +
      gutter;
    if (window.innerWidth < 900) {
      padding =
        innerTopGutter +
        "px 0px " +
        Gutters.spacings[this.props.blockStyle.inner_btm] +
        "px 0px";
    }
    if (typeof this.props.data.field_link_2 !== "undefined") {
      padding = "0px";
    }
    return (
      <Row
        padding={padding}
        margin={margin}
        bgi={bg.bgimg}
        bgc={bg.bgc}
        bgh={window.innerWidth < 900 ? "auto" : bg.bgh}
        display="block"
        className={"tor " + linkColor}
        styles={{ ...Styles.containerStyles }}
        bgSize={bg.bgSize}
      >
        {this.returnVideo()}
        {this.returnTitleBar()}
        {this.returnHeader(bg.boxText, rowdata.field_text_1)}
        {this.returnBoxTextOrNot(
          bg,
          rowdata.field_longtext_1,
          rowdata.field_text_1
        )}
      </Row>
    );
  }
}

export default TextOnlyRow;
